import watch from 'redux-watch'
import { AppStore } from 'src/client/store'
import { refreshOptimizelyFlags } from 'actions/OptimizelyActions'

/** Min interval between /api/flags polls — limits how quickly client picks up flag changes */
const REFRESH_THROTTLE_MS = 60 * 1000 // 1 minute

export function watchOptimizely(store: AppStore) {
  let lastRefreshTime = Date.now()

  store.subscribe(
    watch(store.getState, 'router.location.pathname')(() => {
      const now = Date.now()
      if (now - lastRefreshTime >= REFRESH_THROTTLE_MS) {
        lastRefreshTime = now
        store.dispatch(refreshOptimizelyFlags())
      }
    }),
  )
}
